module.exports = __webpack_public_path__ + "static/assets/8c07dca0e3f9f9c84b2fd70f4f1fbff9.png";